export default "__VITE_ASSET__DGxMAFyr__"